export default function EmptyState({ icon: Icon, baslik, aciklama, children }) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-12">
      {Icon && (
        <span className="w-11 h-11 rounded-xl bg-slate-100 text-slate-400 flex items-center justify-center mb-3">
          <Icon size={20} />
        </span>
      )}
      <div className="text-sm font-medium text-slate-600">{baslik}</div>
      {aciklama && <div className="text-xs text-slate-400 mt-1 max-w-sm">{aciklama}</div>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
